/**
 * Client-side portal type config.
 *
 * showNavigation: false hides sidebar, header, and mobile nav (single-page portals).
 *
 * home: the child route path PortalLayout navigates to after authentication.
 *       Must match a path defined in portalRoutes.js.
 */
const portalTypes = {
    customerPortal:   { showNavigation: true,  home: 'welcome' },
    supplierPortal:   { showNavigation: true,  home: 'welcome' },
    invitation:       { showNavigation: false, home: 'accept' },
    joinOrganization: { showNavigation: false, home: 'acceptJoin' },
    resetPassword:    { showNavigation: false, home: 'resetPassword' }
};

export default portalTypes;
